import { FC } from 'react';
import styled from 'styled-components';
import AchievementCard, { IAchievementCard } from '../AchievementCard/AchievementCard';

const Container = styled.section`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-template-rows: max-content 1fr;
`;

const CardList = styled.section<{ count: number; spaced?: boolean }>(({ theme, count, spaced }) => {
  const { color } = theme;

  return `
    display: grid;
    grid-template-columns: repeat(${count}, 1fr);
    grid-gap: ${spaced ? '23px' : '8px'};
    padding-bottom: 29px;
    border-bottom: 1px solid ${color.grayscale[0]}10;
    margin-bottom: 12px;
    grid-column: 1 / span 2;
    grid-row: 2;
  `;
});

const Heading = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-family: ${type.face};
    font-size: ${type.size.regular};
    font-weight: ${type.weight.bold};
    line-height: 1.1875rem;
    text-transform: uppercase;
    margin: 0 0 21px;
    flex-shrink: 1;
    grid-column: 1;
    grid-row: 1;
  `;
});

const ViewAll = styled.button(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.primary.regular};
    font-family: ${type.face};
    font-weight: ${type.weight.bold};
    font-size: ${type.size.tiny};
    grid-column: 2;
    grid-row: 1;
    border: 0;
    background-color: transparent;
    margin: 0 0 21px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  `;
});

export interface IAchievementCardList {
  achievements: IAchievementCard[];
  displayCount?: number;
  spaced?: boolean;
  viewAllAction?: () => void;
}

const AchievementCardList: FC<IAchievementCardList> = ({ achievements, displayCount, spaced, viewAllAction }) => {
  const achievementArray = typeof displayCount === 'number' ? achievements.slice(0, displayCount) : achievements;

  const cardLoop = achievementArray.map((achievementCardProps: IAchievementCard, index: number) => {
    return <AchievementCard key={`achievementCard-${index}`} {...achievementCardProps} />;
  });

  return (
    <Container className="gamification_tour_1">
      <Heading>In Progress</Heading>

      {viewAllAction && (
        <ViewAll type="button" onClick={viewAllAction} className="gamification_tour_3">
          View all
        </ViewAll>
      )}

      <CardList count={displayCount || 3} spaced={spaced}>
        {cardLoop}
      </CardList>
    </Container>
  );
};

export default AchievementCardList;
